export default __webpack_public_path__ + "static/media/DOGE.ef0c3649.jpg";